import { Layout } from '@/components/layout/Layout';
import { NotificationsPanel } from './NotificationsPanel';

export function Notificacoes() {
  return (
    <Layout breadcrumbs={[{ label: 'Notificações' }]}>
      <NotificationsPanel />
    </Layout>
  );
}
